<template>
  <v-container>
    <h1 class="text-h4 mb-2">Gallery</h1>
    <Sorter v-model="sort"/>
    <div v-if="loaded" class="gallery" gutter=".gutter" transition-duration="0s" v-masonry fit-width="true">
      <router-link class="gallery-item" v-masonry-tile v-for="image in images" :key="image" :to="{ name: 'Image', params: { name: image } }">
        <v-sheet
          :style="{ backgroundImage: `url(${apiUrl}/thumb/${image})` }"
          class="picture-sheet"
          color="white"
          elevation="1"
          height="250"
          width="250"
        ></v-sheet>
      </router-link>
      <div class="gutter"></div>
    </div>
    <p v-if="loaded && !images.length">There is nothing here...</p>
    <v-pagination v-model="page" :length="total"></v-pagination>
  </v-container>
</template>

<script>
import axios from '../plugins/axios'
import Sorter from '../components/Sorter'

export default {
  components: {
    Sorter
  },
  data: () => ({
    apiUrl: process.env.VUE_APP_API_URL,
    loaded: false,
    sort: {
      sort: 'date',
      desc: true
    },
    page: 1,
    pageSize: 8
  }),
  computed: {
    images () {
      return this.$store.getters.gallery.slice((this.page - 1) * this.pageSize, this.page * this.pageSize)
    },
    total () {
      return Math.ceil(this.$store.getters.gallery.length / this.pageSize)
    }
  },
  methods: {
    getHashSort () {
      try {
        const decodedHash = decodeURIComponent(location.hash)
        return JSON.parse(decodedHash.replace(/^#/, ''))
      } catch (error) {
        return null
      }
    },
    setHashSort (value) {
      history.replaceState(null, null, `#${JSON.stringify(value)}`)
    }
  },
  async created () {
    const hashSort = this.getHashSort()

    if (hashSort) {
      this.sort = hashSort
    }

    const result = await axios.get(`/gallery`, { params: this.sort })
    this.$store.dispatch('setGallery', result.data.images)
    this.setHashSort(this.sort)
    this.loaded = true
  },
  watch: {
    async sort () {
      this.loaded = false
      const result = await axios.get(`/gallery`, { params: this.sort })
      this.$store.dispatch('setGallery', result.data.images)
      this.setHashSort(this.sort)
      this.loaded = true
    }
  }
}
</script>

<style scoped>
.gallery {
  margin: 0 auto;
}

.gallery-item {
  margin-bottom: 25px;
}

.gutter {
  width: 25px;
}

.picture-sheet {
  background-size: cover;
  background-position: center;
}
</style>
